import { ApplicationInsights } from "@microsoft/applicationinsights-web";
import { ReactPlugin } from "@microsoft/applicationinsights-react-js";
import { ITelemetryItem } from "@microsoft/applicationinsights-core-js";

const reactPlugin = new ReactPlugin();
const appInsights = new ApplicationInsights({
    config: {
        instrumentationKey: process.env.REACT_APP_INSTRU_KEY,
        extensions: [reactPlugin],
        extensionConfig: {
            [reactPlugin.identifier]: {}
        },
        enableAutoRouteTracking: true,
        enableCorsCorrelation: false,
        enableDebug: true,
    }
});

appInsights.loadAppInsights();

let telemetryUserId = "anonymous";

appInsights.addTelemetryInitializer((envelope: ITelemetryItem) => {
    const baseData = envelope.baseData as { properties?: Record<string, unknown> } | undefined;
    if (!baseData) {
        return true;
    }

    baseData.properties = {
        ...(baseData.properties || {}),
        user_id: telemetryUserId,
    };

    return true;
});

export function setTelemetryUserContext(userId: string, accountId?: string) {
    telemetryUserId = userId || "anonymous";
    appInsights.setAuthenticatedUserContext(telemetryUserId, accountId, false);
}

export function clearTelemetryUserContext() {
    telemetryUserId = "anonymous";
    appInsights.clearAuthenticatedUserContext();
}

export { appInsights, reactPlugin }